var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.readValue)?_c('div',_vm._l((_vm.readValue),function(item,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(item)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }